<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-5">
                  <div class="row">
                    <div class="col-10">
                      <CIcon size="sm" name="cil-building" />Cursos ofertados
                    </div>
                    <div class="col-2">
                      <router-link
                        to="/cursos-ofertados/crear"
                        custom
                        v-slot="{ href, navigate }"
                        v-if="isMobile"
                      >
                        <a
                          :href="href"
                          class="card-header-action btn btn-sm btn-primary"
                          @click="navigate"
                        >
                          <CIcon size="sm" name="cil-plus" />
                        </a>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-7">
                  <div class="row">
                    <div class="col-xl-3">
                      <div class="form-group">
                        <label
                          class="float-right"
                          for="courses_syllabus_position"
                          >Ordenar por Pensum:</label
                        >
                        <br />
                        <CSwitch
                          class="float-right"
                          :color="color"
                          v-bind="mode"
                          :checked.sync="columnFilter.ascForPensum"
                          v-model="columnFilter.ascForPensum"
                          id="courses_syllabus_position"
                          @change="filterTable"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-2">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-6 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >
                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <!-- Pensum -->
                    <div class="col-6 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="syllabus_id"
                          >Pensum:</label
                        >
                        <b-form-select
                          v-model="columnFilter.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="course_id"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>

                    <div class="col-12 col-xl-1">
                      <div class="card-header-actions">
                        <br />
                        <router-link
                          to="/cursos-ofertados/crear"
                          custom
                          v-slot="{ href, navigate }"
                          v-if="!isMobile"
                        >
                          <a
                            :href="href"
                            class="
                              card-header-action
                              btn btn-sm btn-primary
                              mb-2
                              float-right
                            "
                            @click="navigate"
                          >
                            <CIcon size="sm" name="cil-plus" />
                          </a>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen cursos ofertados registrados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #couse-filter>
                <b-form-select
                  v-model="columnFilter.couse"
                  :options="typeOfCourseOptions"
                  value-field="value"
                  text-field="name"
                  id="couse"
                  size="sm"
                  @change="filterTable"
                >
                </b-form-select>
              </template>
              <template #parallel-filter>
                <b-form-select
                  v-model="columnFilter.parallel"
                  :options="parallelOptions"
                  value-field="value"
                  text-field="name"
                  id="parallel"
                  size="sm"
                  @change="filterTable"
                >
                </b-form-select>
              </template>
              <template #course_id-filter>
                <v-select
                  :options="coursesOptions"
                  label="name"
                  :reduce="(course) => course.id"
                  id="course_id"
                  v-model="columnFilter.course_id"
                  @input="filterTable"
                >
                </v-select>
              </template>
              <template #type_of_course-filter>
                <b-form-select
                  v-model="columnFilter.type_of_course"
                  :options="typeOfCourseOptions"
                  value-field="value"
                  text-field="name"
                  id="type_of_course"
                  size="sm"
                  @change="filterTable"
                >
                </b-form-select>
              </template>
              <template #enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>

              <template #course_id="{ item }">
                <td>
                  {{ item.course_name }}
                </td>
              </template>

              <template #person_fullname="{ item }">
                <td>
                  {{
                    item.teacher_id
                      ? item.person_fullname
                      : "-- Sin profesor designado --"
                  }}
                </td>
              </template>

              <template #period="{ item }">
                <td>
                  <span>Gestión: {{ item.courses_offered_year }}</span>
                  <br />
                  <span>
                    Periodo:
                    {{ item.period | period }}
                  </span>
                </td>
              </template>

              <template #parallel="{ item }">
                <td>{{ item.parallel | parallel }}</td>
              </template>

              <template #time="{ item }">
                <td style="white-space: pre">
                  <span>{{ item | time_courses_offered }}</span>
                </td>
              </template>

              <template #type_of_course="{ item }">
                <td>{{ item.type_of_course | type_of_course }}</td>
              </template>

              <template #syllabus_id="{ item }">
                <td>
                  {{
                    item.syllabus_description + " v." + item.syllabus_version
                  }}
                </td>
              </template>

              <template #enabled="{ item }">
                <td>
                  <CBadge color="success" v-if="item.enabled == true"
                    >Activo</CBadge
                  >
                  <CBadge color="danger" v-else>Inactivo</CBadge>
                </td>
              </template>

              <template #detail="{ item }">
                <td>
                  <b-button-group size="xs">
                    <b-button
                      :to="{ path: 'cursos-ofertados/editar/' + item.id }"
                      variant="warning"
                      title="Editar"
                      v-auth-roles="{
                        user: userAuth,
                        roles: [const_roles.ROLE_ADMINISTRATOR],
                      }"
                    >
                      <CIcon size="sm" name="cil-pencil" />
                    </b-button>
                    <b-button
                      @click="modalDelete(item.id)"
                      variant="danger"
                      title="Eliminar"
                      v-auth-roles="{
                        user: userAuth,
                        roles: [const_roles.ROLE_ADMINISTRATOR],
                      }"
                    >
                      <CIcon size="sm" name="cil-trash" />
                    </b-button>
                    <b-button
                      @click="modalRegisteredStudentList(item.id)"
                      variant="primary"
                      title="Ver estudiantes"
                      v-auth-roles="{
                        user: userAuth,
                        roles: [
                          const_roles.ROLE_SECRETARY,
                          const_roles.ROLE_ADMINISTRATOR,
                        ],
                      }"
                    >
                      <CIcon
                        size="sm"
                        name="cil-people"
                        title="Ver estudiantes"
                      />
                    </b-button>
                  </b-button-group>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
    <section v-if="modShowDelCourseOffered">
      <CourseOfferedDeleteModal
        :course_offered_id="course_offered_id"
        :modShowDelCourseOffered="modShowDelCourseOffered"
        @courseOfferedDeleteModal="afterDeleteCourseOffered"
      ></CourseOfferedDeleteModal>
    </section>
    <section v-if="modShowRegisteredStudentList">
      <RegisteredStudentsListModal
        :course_offered_id="course_offered_id"
        :modShowRegisteredStudentList="modShowRegisteredStudentList"
        @registeredStudentsListModal="afterRegisteredStudentList"
      ></RegisteredStudentsListModal>
    </section>
  </section>
</template>
<script>
import {
  BAlert,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesOffered from "@/plugins/services/courses-offered";
import Syllabus from "@/plugins/services/syllabus";
import Courses from "@/plugins/services/courses";
// components
import CourseOfferedDeleteModal from "@/entities/courses-offered/CourseOfferedDeleteModal.vue";
import RegisteredStudentsListModal from "@/entities/registrations/RegisteredStudentsListModal.vue";

export default {
  name: "CoursesOfferedList",
  components: {
    BAlert,
    BButton,
    BButtonGroup,
    CourseOfferedDeleteModal,
    RegisteredStudentsListModal,
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width:8px;",
        },
        {
          key: "person_fullname",
          label: "Profesor",
          _style: "min-width:160px;",
        },
        {
          key: "course_id",
          label: "Curso",
          _style: "width:15%;",
        },
        {
          key: "period",
          label: "Periodo",
          _style: "min-width:95px;",
          filter: false,
        },
        {
          key: "parallel",
          label: "Paralelo",
          _style: "width:6%;",
        },
        {
          key: "time",
          label: "Horario",
          sorter: false,
          filter: false,
          _style: "width:15%;",
        },
        {
          key: "syllabus_id",
          label: "Pensum",
          _style: "min-width:100px;",
          filter: false,
        },
        {
          key: "type_of_course",
          label: "Tipo de curso",
          _style: "width:8%;",
        },
        {
          key: "classroom",
          label: "Nº Aula",
          _style: "width:5%;",
        },
        {
          key: "enabled",
          label: "Estado",
          filter: true,
          _style: "width:7%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      columnFilter: {
        column: "created_at",
        asc: false,
        ascForPensum: false,
        enabled: true,
        courses_offered_year: new Date().getFullYear(),
      },
      const_roles: Constants.roles,
      enabledOptions: Constants.enabledOptions,
      coursesOfferedYearsOptions: [],
      parallelOptions: Constants.parallelOptions,
      periodOptions: Constants.periodOptions,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      syllabusOptions: [],
      coursesOptions: [],
      color: "primary",
      mode: { shape: "pill" },
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      course_offered_id: 0,
      modShowDelCourseOffered: false,
      modShowRegisteredStudentList: false,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    isMobile() {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  },
  created() {
    let colFilter = this.$store.state.columnFilter;
    if (colFilter) {
      if (colFilter.name == "courses-offered") {
        this.page = this.$store.state.columnFilter.page;
        this.columnFilter = this.$store.state.columnFilter.columnFilter;
      }
    }
    this.getAll(this.columnFilter, this.page);
    this.getCoursesOfferedYears();
    this.getSyllabus();
    this.getCourses();
  },
  watch: {
    "columnFilter.ascForPensum"(columnFilter) {
      this.filterTable(this.columnFilter);
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Utils.columnFilter("courses-offered", q, page);
      CoursesOffered.alltwo(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: "created_at",
        asc: false,
        ascForPensum: false,
        enabled: true,
        courses_offered_year: new Date().getFullYear(),
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    modalDelete(id) {
      this.modShowDelCourseOffered = true;
      this.course_offered_id = id;
    },
    afterDeleteCourseOffered(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowDelCourseOffered = response.modalShow;
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCourses() {
      Courses.selectAll(null)
        .then((res) => {
          this.coursesOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modalRegisteredStudentList(id) {
      this.modShowRegisteredStudentList = true;
      this.course_offered_id = id;
    },
    afterRegisteredStudentList(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowRegisteredStudentList = response.modalShow;
    },
    mobileCheck() {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  },
};
</script>
